import { Div, Ref, Span, NumberInput } from '@tblabs/truffle';


export class NumberInputWithIcon extends Div
{
    constructor(label: string, ref: Ref<number>, min: number, max: number, step = 1, info: string)
    {
        super();
        this.Class("number-input-with-icon tooltip");

        this.Append(
            new Span(info).Class("tooltip-text"),
            new Span(label).Class("icon"),
            new NumberInput(ref).Min(min).Max(max).Step(step).RemoveAllClasses().Class("input")
        );
    }
}
